export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet the Team</h2>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-6 col-sm-6 team">
                  <div className="thumbnail">
                    <div className="col-md-6">
                      <img src={d.img} alt="..." className="team-img" />
                      <div className="caption">
                        <h4>{d.name}</h4>
                        <p>{d.job}</p>
                        <div className="social">
                          <a href={d.facebook}>
                            <i className="fa fa-facebook"></i>
                          </a>
                          <a href={d.twitter}>
                            <i className="fa fa-twitter"></i>
                          </a>
                          <a href={d.linkedin}>
                            <i className="fa fa-linkedin"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="caption1">
                        <p>{d.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
